import "../constants/index.js";
import { DEFAULT_TRANSITION_DURATION } from "../constants/animations.js";
const delay = (ms = DEFAULT_TRANSITION_DURATION) => new Promise((resolve) => setTimeout(resolve, ms));
const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return Promise.resolve();
  } catch (error) {
    return Promise.reject("Failed to copy to clipboard!");
  }
};
const translate = (t, text) => {
  if (text === null || text === void 0) return "";
  return t ? t(text) : text;
};
export {
  copyToClipboard,
  delay,
  translate
};
